import React, { useState, useEffect, useContext } from 'react'
import userCheck from '../../../Assets/Images/user-check.svg';
import download from '../../../Assets/Images/download.svg';
import search from '../../../Assets/Images/FilterSearchIcon.png';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { CatalogContext } from '../../../Context/CatalogContext';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { CSVLink } from "react-csv";


export default function PageHeader({ handleBack, currentPage }) {
  const [menu, setMenu] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const location  = useLocation();
  const { totalCount, handleSortChange, sortOption, handleSearchChange, filteredData } = useContext(CatalogContext);
  const navigate = useNavigate();

  const headers = [
    { label: "CONGREGANT", key: "congregant" },
    { label: "AGE", key: "age" },
    { label: "GENDER", key: "gender" },
    { label: "STATUS", key: "status" },
    { label: "OCCUPATION", key: "occupation" },
    { label: "OCCUPATIONAL_GROUP", key: "occupational_group" },
    { label: "INDUSTRY", key: "industry" },
    { label: "SEN", key: "sen" },
    { label: "PRC", key: "prc" },
    { label: "HIST", key: "hist" },
    { label: "INTR", key: "intr" },
  ];

  useEffect(() => {
    let dt = filteredData.map(item => {
      return { 
        congregant: item.name,
        age: item.age,
        gender: item.gender,
        status: item.status,
        occupation: item.occupation,
        occupational_group: item.occupational_group,
        industry: item.industry,
        sen: item.sentiments,
        prc: item.practices,
        hist: item.history,
        intr: item.interest,
      }
    });
    setCsvData(dt);
  }, [filteredData])

  const RightMenu = () => {
    if (!menu) {
      setMenu(!menu);
      document.body.querySelector('.right').style.display = 'flex';
    }
    else {
      setMenu(!menu);
      document.body.querySelector('.right').style.display = 'none';
    }
  }
  return (
    <div className="insight-header">
      <div className="heading">
        <div className="left">
          <Button onClick={handleBack}>
            <ArrowBackIosIcon className='left-arrow' /> <p>BACK</p>
          </Button>
          <p><span onClick={() => navigate('/dashboard')}>DASHBOARD /</span> {currentPage}</p>
        </div>
        {/* <button className="right-menu" onClick={RightMenu}>
          {!menu?<MenuIcon/>:<CloseIcon/>}
        </button> */}
        <div className="right">
          <div className="surveys">
            <img src={userCheck} alt="" />
            <p>{totalCount} surveys</p>
          </div>
          <div className="right-inner">
            {/* <div className='sort'>
              <select name="sort" id="sort" onChange={handleSortChange}>
                <option value="A-Z" className='label'>Sort A-Z</option>
                <option value="Z-A">Sort Z-A</option>
              </select>
            </div> */}
            <div className='sort'>
              <FormControl fullWidth sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="sort">Sort</InputLabel>
                <Select labelId="sort" id="sort" value={sortOption} label="Sort" onChange={handleSortChange} >
                  <MenuItem value="A-Z">Sort A-Z</MenuItem>
                  <MenuItem value="Z-A">Sort Z-A</MenuItem>
                  <MenuItem value="AVG">Average Rating (Asc)</MenuItem>
                  <MenuItem value="AVG-D">Average Rating (Desc)</MenuItem>
                  <MenuItem value="SEN">SEN Rating (Asc)</MenuItem>
                  <MenuItem value="SEN-D">SEN Rating (Desc)</MenuItem>
                  <MenuItem value="PRC">PRC Rating (Asc)</MenuItem>
                  <MenuItem value="PRC-D">PRC Rating (Desc)</MenuItem>
                  <MenuItem value="HIST">HIST Rating (Asc)</MenuItem>
                  <MenuItem value="HIST-D">HIST Rating (Desc)</MenuItem>
                  <MenuItem value="INTR">INTR Rating (Asc)</MenuItem>
                  <MenuItem value="INTR-D">INTR Rating (Desc)</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className='search'>
              <input type="text" placeholder='Search' onChange={handleSearchChange} />
              <img src={search} width={20} height={20} alt="" />
            </div>
            <CSVLink data={csvData} headers={headers} filename={"catalog.csv"}>
              <Button className="cta">
                <img src={download} alt="" />
                Export
              </Button>
            </CSVLink>
          </div>
        </div>
      </div>
      <div className="bottom right">
        {/* <div className='sort'>
          <select name="sort" id="sort" onChange={handleSortChange}>
            <option value="A-Z">Sort A-Z</option>
            <option value="Z-A">Sort Z-A</option>
          </select>
        </div> */}
        <div className='sort'>
          <FormControl fullWidth sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="sort">Sort</InputLabel>
            <Select labelId="sort" id="sort" value={sortOption} label="Sort" onChange={handleSortChange} className="custom-select" >
              <MenuItem value="A-Z">Sort A-Z</MenuItem>
              <MenuItem value="Z-A">Sort Z-A</MenuItem>
            </Select>
          </FormControl>
        </div>
        <div className='search'>
          <input type="text" placeholder='Search' onChange={handleSearchChange} />
          <img src={search} width={20} height={20} alt="" />
        </div>
        <Button className="cta">
          <img src={download} alt="" />
          Export
        </Button>
      </div>
    </div>
  )
}
